
import { useState } from "react";

export const useOnboardingSteps = (totalSteps = 6) => {
  const [step, setStep] = useState(1);

  const nextStep = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    }
  };

  const previousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return {
    step,
    totalSteps,
    nextStep,
    previousStep,
    isFirstStep: step === 1,
    isLastStep: step === totalSteps,
  };
};
